import { sortAsc } from '@strata/helper-functions';
import { GridWithSearch, PrimaryData, SecondaryData } from '@strata/react-grid';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const getParentProductMap = (parentProducts) =>
    Object.fromEntries(
        (parentProducts ?? []).map((parentProduct) => [
            parentProduct.parent_product_service,
            parentProduct.display_name,
        ]),
    );

export const ProductServiceList = () => {
    const navigate = useNavigate();
    const productServices = useGet('/reference/productservices/summaryandcodes');
    const parentProductMap = getParentProductMap(useGet('/reference/parent_product_services'));

    return (
        <div className="sds_main-content__container">
            <ListPageHeader
                pageTitle="Product Services"
                buttons={[
                    {
                        label: 'Create Product Service',
                        path: `/product-service/${CREATE_ROUTE}`,
                    },
                ]}
            />
            <div className="sds_main-content__grid">
                <GridWithSearch
                    data={productServices}
                    isLoading={!productServices}
                    columns={[
                        {
                            accessorKey: 'oid',
                            header: 'Product OID',
                            size: 20,
                            cell: ({ getValue }) => <PrimaryData data={getValue()} />,
                        },
                        {
                            accessorKey: 'parent_product_service',
                            header: 'Parent Product',
                            size: 20,
                            cell: ({ getValue }) => (
                                <SecondaryData
                                    data={parentProductMap?.[getValue()] ?? getValue()}
                                />
                            ),
                        },
                        {
                            accessorKey: 'codes',
                            header: 'Service Codes',
                            size: 100,
                            cell: ({ getValue }) => (
                                <SecondaryData data={getValue()?.sort(sortAsc)?.join(', ')} />
                            ),
                        },
                        {
                            accessorKey: 'gpi',
                            header: 'GPI',
                            size: 20,
                        },
                    ]}
                    sortProperties={[{ id: 'oid', desc: false }]}
                    onRowClick={(row) => navigate(`/product-service/${row.oid}`)}
                />
            </div>
        </div>
    );
};
